// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__36aOC","emails":"CreateEditClinics_emails__1ZrYc","emailTagLabel":"CreateEditClinics_emailTagLabel__rbAMC"};